import styled from 'styled-components';

export const StyledServices = styled.section`
  background-color: var(--light-bg);
  padding: 100px 0;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  h2 {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 50px;
    color: var(--text-color);
    font-family: Gunar Thin, sans-serif;
    font-weight:bold;
    letter-spacing: 2px;

    .highlight {
      color: var(--primary-color);
    }
  }
`;

export const ServiceCategories = styled.div`
  margin-top: 40px;
`;

export const CategoryTabs = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;

export const TabBtn = styled.button`
  padding: 12px 30px;
  background-color: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 10px;
  color: var(--text-color);

  &.active {
    border-bottom-color: var(--primary-color);
    color: var(--primary-color);
  }
`;

export const CategoryContent = styled.div`
  display: none;

  &.active {
    display: block;
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
`;

export const ServiceCard = styled.div`
  background-color: var(--card-bg);
  border-radius: 8px;
  padding: 30px;
  box-shadow: var(--box-shadow);
  transition: all 0.3s ease;
  height: 100%;
  border-left: 4px solid var(--primary-color);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, var(--primary-color), transparent);
  }

  .icon {
    width: 70px;
    height: 70px;
    background-color: rgba(255, 107, 0, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 1.8rem;
    color: var(--primary-color);
  }

  h3 {
    color: var(--text-color);
    margin-bottom: 15px;
  }

  p {
    color: var(--text-secondary);
    margin-bottom: 0;
  }
  
`;
export const SectionSubtitle = styled.h3`
  font-family: Gunar Thin, sans-serif;
  font-size: 1.8rem;
  font-weight: 600;
  text-align: center;
  color: var(--text-color);
  margin-bottom: 30px;
  margin-top: 60px;
  position: relative;
  display: inline-block;
  width: 100%;
  letter-spacing: 2px;

  &::after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: var(--primary-color);
    margin: 10px auto 0;
  }
`;
